import CryptoJS from "crypto-js";
import SecureStorage from "secure-web-storage";

const SECRET_KEY = "girnarsoftInternationalLoan";

const secureStorage = new SecureStorage(localStorage, {
  hash: function hash(key) {
    key = CryptoJS.SHA256(key, SECRET_KEY);
    return key.toString();
  },
  encrypt: function encrypt(data, secretKey=SECRET_KEY) {
    data = CryptoJS.AES.encrypt(data, secretKey);
    data = data.toString();
    return data;
  },
  decrypt: function decrypt(data, secretKey=SECRET_KEY) {
    data = CryptoJS.AES.decrypt(data, secretKey);
    data = data.toString(CryptoJS.enc.Utf8);
    return data;
  }
});

export default secureStorage;